import { render, staticRenderFns } from "./leftMessage.vue?vue&type=template&id=5ac4f58a&scoped=true"
import script from "./leftMessage.vue?vue&type=script&lang=js"
export * from "./leftMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac4f58a",
  null
  
)

export default component.exports